import reducer from './reducer'
import * as selectors from './selectors'

export { selectors }
export const { setActiveClientId, setUserClients, setActiveClientIdStarted } =
  reducer.actions
export default reducer
